import { createReducer } from '@reduxjs/toolkit';

import isEqual from 'lodash/isEqual';
import { AdminEmailsFilter, AdminEmailsSortBy } from '../../../api/admin-emails/types';
import { logoutThunk } from '../../user';
import {
  setAdminEmailsFilter,
  setAdminEmailsKeyword,
  setAdminEmailsPage,
  setAdminEmailsSort,
  setAdminEmailsSortFilter,
} from './emails.actions';

interface State {
  sortBy?: AdminEmailsSortBy;
  keyword?: string;
  currentPage: number;
  filter?: AdminEmailsFilter;
}

const initialState: State = {
  sortBy: undefined,
  keyword: undefined,
  currentPage: 1,
};

export const adminEmailsReducer = createReducer(initialState, (builder) => {
  builder.addCase(logoutThunk.fulfilled, () => {
    return initialState;
  });
  builder.addCase(setAdminEmailsSort, (state, { payload }) => {
    if (isEqual(state.sortBy, payload)) {
      return;
    }
    state.sortBy = payload.sort;
    state.currentPage = 1;
  });

  builder.addCase(setAdminEmailsKeyword, (state, { payload }) => {
    if (state.keyword === payload) {
      return;
    }
    state.keyword = payload;
    state.currentPage = 1;
  });

  builder.addCase(setAdminEmailsPage, (state, { payload }) => {
    state.currentPage = payload;
  });
  builder.addCase(setAdminEmailsFilter, (state, { payload }) => {
    state.filter = payload.filter;
  });
  builder.addCase(setAdminEmailsSortFilter, (state, { payload }) => {
    state.filter = payload.filter;
    if (isEqual(state.sortBy, payload)) {
      return;
    }
    state.sortBy = payload.sort;
    state.currentPage = 1;
  });
});
